export const FundedWalletListHead = ["Name", "Amount", "Description", "Date"];
